import './common.scss';
import './step-indicator.scss';
import addMore from './add-more';
import openInClosableTab from './open-in-closable-tab';
import richEditor from './rich-editor';
import selectDynamicOptions from './select-dynamic-options';
import showDependsOnSelect from './show-depends-on-select';
import showDependsOnSelectOther from './show-depends-on-select-other';
import showDependsOnRadio from './show-depends-on-radio';
import validationSummary from './validation-summary';
import clearCheckboxInGroup from './clear-checkbox-in-group';
import groupHideExtra from './group-hide-extra';
import gsSelect from './gs-select';
import gsTypeahead from './gs-typeahead';
import { otherAutoselectClear } from './other-autoselect-clear';
import { checkboxGroupDependsOnRadio } from './checks-group-depends-on-radio';
import { drosTopicList } from './drosTopicList';


const baseUrl = (window as any).GS_BASE_URL;
export default function () {
    var targets = document.querySelectorAll("[data-gs-toggle]");
    for (let i = 0; i < targets.length; ++i) {
        var targetElem = targets[i] as HTMLElement;
        var toggleName = targetElem.dataset['gsToggle'];
        try {
            switch (toggleName) {
                case 'add-more':
                    addMore(targetElem);
                case 'open-in-closable-tab':
                    openInClosableTab(targetElem);
                    break;
                case 'add-more-no-tab':
                    addMore(targetElem);
                    break;
                case "rich-editor":
                    richEditor(targetElem);
                    break;
                case "select-dynamic-options":
                    selectDynamicOptions(targetElem);
                    break;
                case 'show-depends-on-select':
                    showDependsOnSelect(targetElem);
                    break;
                case 'show-depends-on-select-other':
                    showDependsOnSelectOther(targetElem);
                    break;
                case 'show-depends-on-radio':
                    showDependsOnRadio(targetElem);
                    break;
                case 'validation-summary':
                    validationSummary(targetElem);
                    break;
                case 'clear-checkbox-in-group':
                    clearCheckboxInGroup(targetElem);
                    break
                case 'gs-select':
                    gsSelect(baseUrl, targetElem);
                    break
                case 'gs-typeahead':
                    gsTypeahead(baseUrl, targetElem);
                    break;
                case 'group-hide-extra':
                    groupHideExtra(targetElem);
                    break;
                case 'other-autoselect-clear':
                    otherAutoselectClear(targetElem);
                    break;
                case 'checkbox-group-depends-on-radio':
                    checkboxGroupDependsOnRadio(targetElem);
                    break;
                case 'dros-topic-list':
                    drosTopicList(targetElem);
                    break;
                default:
                    console.error(`unknown toggleName ${toggleName}`);
            }
        }
        catch (e) {
            (console.error || console.log).call(console, e.stack || e);
        }
    }
}
